import { Component, OnInit, ViewContainerRef, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { ModalDialogService } from 'ngx-modal-dialog';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { AlgConditionModalComponent } from '../../dialogs/alg-condition-modal/alg-condition-modal.component';
import { consensoVeloceConditionsText, conditionTextList, paymentConditionTypeToReplace } from '../../../models/contitions';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UtilsService } from '../../../services/utils.service';
import { AlgConsensoService } from '../../../services/alg-consenso.service';
import { ApiService } from '../../../services/api.service';
import { AlgConditionPrivacyModalSecondComponent } from '../../dialogs/alg-condition-privacy-modal-second/alg-condition-privacy-modal-second.component';
import { AlgPdfModalComponent } from '../../dialogs/alg-pdf-modal/alg-pdf-modal.component';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { VulnerabilityType } from '../../../models/product';
@Component({
  selector: 'alg-consenso-general-condition',
  templateUrl: './alg-consenso-general-condition.component.html',
  styleUrls: ['./alg-consenso-general-condition.component.scss'],
})
export class AlgConsensoGeneralConditionComponent implements OnInit, OnDestroy {
  @Output() isFormValid: EventEmitter<any> = new EventEmitter<any>();
  @Output() checkboxOutputClause = new EventEmitter<boolean>();
  @Output() checkboxOutputConsents = new EventEmitter<boolean>();

  @Input() data: any;
  @Input() checkboxInput: Object = {};
  @Input() opportunityId: string;
  @Input() isProductGasVulnerable: boolean;
  @Input() productFamily: string;
  public actualPromoName$: string;
  public actualDiscountIsValid$: boolean;
  public contractForm: FormGroup;
  public promo$: Observable<string>;
  public policiesUrls: any = {};
  private opportunityCategoryNumber: number;
  private opportunityCategoryNumbWithVulnerabilityCheck: number;
  private ngUnsubscribe = new Subject<void>();
  public consentsContent: any;
  public clauseContent: any;
  public supplyType = null;
  public placet = null;
  public isUnipol: boolean;
  public controlCheckboxesClause: boolean;
  public controlCheckboxesConsents: boolean;
  public productGasVulnerable: boolean;
  public vulnerabilityType: VulnerabilityType;
  public linkToregulationUnicaCoop: string =
    'https://s3.eu-central-1.amazonaws.com/documenti.lucegasecoop.it/00-statico/regolamenti/OPERAZIONE+A+PREMI+UNICA+COOP.pdf';

  public readAcceptances = {
    economic: false,
    supplies: false,
    cadastral: false,
    clause: false,
    consents: false,
  };

  public readAcceptance = {
    cteCondition: false,
    cfgCondition: false,
    cadastralCondition: false,
    clauseCondition: false,
    consentsCondition: false,
  };

  public conditions = [
    {
      label: 'Accetto e prendo visione delle <strong>Condizioni Tecnico economiche</strong>',
      slug: 'economicCondition',
    },
    {
      label: 'Accetto e prendo visione delle <strong>Condizioni generali di fornitura</strong>',
      slug: 'suppliesCondition',
    },
    {
      label: `Accetto e prendo visione dell'<strong>informativa sui dati catastali.</strong>`,
      slug: 'cadastralCondition',
    },
    // tslint:disable-next-line:max-line-length
    {
      label: `Accetto e prendo visione dell'<strong>Accettazione espressa di clausole </strong> ai sensi e per gli effetti di cui agli art.1341 e 1342 cod. civ.`,
      slug: 'clausole',
    },
    {
      label: `Accetto prendo visione dell'<strong>informativa contrattuale e consensi.</strong>`,
      slug: 'constentsCondition',
    },
  ];

  constructor(
    private consensoSerivce: AlgConsensoService,
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef,
    private api: ApiService
  ) {
    this.consensoSerivce.genericConsets$.subscribe((data) => {
      this.readAcceptance.clauseCondition = data.clauseCondition;
      this.readAcceptance.consentsCondition = data.consentsCondition;
      this.readAcceptance.cadastralCondition = data.cadastralCondition;
      this.readAcceptance.cteCondition = data.cteCondition;
      this.readAcceptance.cfgCondition = data.cfgCondition;
    });
    this.promo$ = this.consensoSerivce.approval$.pipe(map((approval) => !!approval && approval.promoCode));
  }

  ngOnInit() {
    // SUBSCRIBE: Save a local copy of policies urls
    this.consensoSerivce.policiesUrl$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((policies) => {
      this.policiesUrls = policies;
    });
    // SUBSCRIBE: Save a local copy of opportunity category number
    this.consensoSerivce.categoryNumber$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((opportunityCategoryNumber) => {
      this.opportunityCategoryNumber = opportunityCategoryNumber;
    });
    this.contractForm = new FormGroup({
      clauseCondition: new FormControl(this.readAcceptance.clauseCondition, {
        validators: [Validators.requiredTrue],
      }),
      consentsCondition: new FormControl(this.readAcceptance.consentsCondition, {
        validators: [Validators.requiredTrue],
      }),
    });

    // Control if there is a promo, then fetch name and if it is a discount
    if (this.data.promoCode !== null || undefined) {
      this.consensoSerivce.fetchNamePromoOpportuniy(this.data.opportunityId);
    }

    // SUBSCRIBE: Get opportunity promo name and discount
    this.consensoSerivce.promoNameAndDiscountValidity$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((result) => {
      this.actualDiscountIsValid$ = !!result && result.isDiscount;
      this.actualPromoName$ = result.promoName.replace(/ /g, '_').toLocaleLowerCase();
    });

    this.contractForm.valueChanges.subscribe((data) => {
      this.readAcceptance.clauseCondition = data.clauseCondition;
      this.readAcceptance.consentsCondition = data.consentsCondition;
    });

    this.vulnerabilityType = this.data.vulnerabilityType;

    this.choosePrivacyText();
    const opporturnityCategory = this.data.product.family.toLowerCase() !== 'placet' && !this.isProductGasVulnerable ? '9' : '';
    this.opportunityCategoryNumbWithVulnerabilityCheck = parseInt(opporturnityCategory + this.opportunityCategoryNumber);
    if (this.data.unipol) {
      this.consentsContent =
        consensoVeloceConditionsText.consentsUnipol.get(this.opportunityCategoryNumbWithVulnerabilityCheck) ||
        consensoVeloceConditionsText.consentsUnipol.get(0);

      this.isUnipol = true;
    }
    if (!this.data.unipol) {
      this.consentsContent =
        consensoVeloceConditionsText.consents.get(this.opportunityCategoryNumbWithVulnerabilityCheck) || consensoVeloceConditionsText.consents.get(0);

      this.isUnipol = false;
    }
    this.clauseContent = consensoVeloceConditionsText.clause.get(this.opportunityCategoryNumber) || consensoVeloceConditionsText.clause.get(0);
  }

  ngOnChanges() {
    this.productGasVulnerable = this.isProductGasVulnerable;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  downloadCTE() {
    const options = {
      product: this.data.product.family.toUpperCase(),
      promo: !this.data.promoCode || this.data.promoCode.length === 0 ? null : this.data.promoCode,
      offerType: this.data.unipol ? 'UNIPOL' : 'ALG',
      priceTypology: this.data.product.priceType,
      placet: this.data.product.family.toLowerCase() === 'placet' ? true : null,
      commodity: this.data.product.type,
      duration:
        this.data.product.family.toUpperCase() === 'CASA AGILE' || this.data.product.family.toUpperCase() === 'CASA AGILE ECOLOGICA'
          ? (this.data.product.duration = 'N%2FA')
          : this.data.product.duration.replace(' Mesi', ''),
      renew: null,
    };
    if (options.duration === 'N/A') {
      options.duration = 'N%2FA';
    }
    return this.api
      .getCTE(options)
      .toPromise()
      .then((data) => this.downloadPdf(data))
      .catch((err) => {
        alert('Error');
      });
  }

  downloadCGF() {
    const options = {
      unipol: this.data.unipol,
      placet: this.data.product.family.toLowerCase() === 'placet' ? true : null,
      commodity: this.data.product.type,
    };
    return this.api
      .getCGF(options)
      .toPromise()
      .then((data) => this.downloadPdf(data))
      .catch((err) => {
        alert('Error');
      });
  }

  public downloadCGFVulnerableProduct() {
    return this.api
      .getCGFVulnerableProduct()
      .toPromise()
      .then((data) => this.downloadPdf(data))
      .catch((err) => {
        console.log('ERROR: ', err);
        alert('Errore nel download del file: ');
      });
  }

  openPDF(index) {
    if (index === 0) {
      this.downloadCTE();
    } else {
      this.downloadCGF();
    }
    return true;
  }

  private choosePrivacyText() {
    this.placet = this.data.product.family.toLowerCase() === 'placet' ? true : null;
    this.supplyType = this.data.product.type === 'Luce & Gas' ? 'DUAL' : this.data.product.type === 'Luce' ? 'LUCE' : 'GAS';
    if (!this.data.unipol) {
      this.isUnipol = false;
    }
    if (this.data.unipol) {
      this.isUnipol = true;
    }
  }

  downloadPdf(data) {
    const newBlob = new Blob([data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(newBlob);
    const pwa = window.open(url);
    if (!pwa || pwa.closed || typeof pwa.closed === 'undefined') {
      alert('Please disable your Pop-up blocker and try again.');
    }
  }

  conditionClicked(type) {
    this.readAcceptances[type] = true;
    switch (type) {
      case 'economic':
        this.downloadCTE();
        break;
      case 'supplies':
        this.productGasVulnerable ||
        (this.data.vulnerabilityType === VulnerabilityType.anagraficAge && this.data.product.family.includes('ALG Vulnerabile Gas Domestico'))
          ? this.downloadCGFVulnerableProduct()
          : this.downloadCGF();
        break;
      default:
        break;
    }
  }

  openModal(modalContent) {
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: modalContent.title,
      childComponent: AlgConditionModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: ' modal-title modal-title-underline',
      },
      data: {
        description: modalContent.description,
      },
    });
  }

  openPrivacyModal(modalContent) {
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: modalContent.title,
      childComponent: AlgConditionPrivacyModalSecondComponent,
      settings: {
        modalClass: 'modal fade ngx-modal modal-privacy',
        bodyClass: 'modalClassBody',
        modalDialogClass: 'modalDialogClass',
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: 'modal-title modal-title-underline modal-title-padding-r',
      },
      data: {
        description: modalContent.description,
        title: modalContent.title,
        placet: modalContent.placet,
        supplyType: modalContent.supplyType,
        modalN: modalContent.modalN,
        unipol: modalContent.unipol,
        isProductVulnerable: modalContent.isProductVulnerable,
        productFamily: modalContent.productFamily,
      },
    });
  }

  readCondition(type, num = 0) {
    let modalContent;
    console.log('type', type);
    let suffix = this.calculateTextSuffix(type);
    if (type === 'clause') {
      modalContent = consensoVeloceConditionsText.clause.get(this.opportunityCategoryNumber) || consensoVeloceConditionsText.clause.get(0);
      this.openModal(modalContent || {});
    } else if (type === 'consents' && !this.data.unipol) {
      modalContent =
        consensoVeloceConditionsText.consents.get(this.opportunityCategoryNumbWithVulnerabilityCheck) || consensoVeloceConditionsText.consents.get(0);
      this.openModal(modalContent || {});
    } else if (type === 'consents' && this.data.unipol) {
      modalContent =
        consensoVeloceConditionsText.consentsUnipol.get(this.opportunityCategoryNumbWithVulnerabilityCheck) ||
        consensoVeloceConditionsText.consentsUnipol.get(0);
      this.openModal(modalContent || {});
    } else if (type === 'attivazioneVeloce') {
      console.log('Attiazione veloce');
      console.log('type + suffix', type + suffix);
      modalContent = consensoVeloceConditionsText.helper[type + suffix] || consensoVeloceConditionsText.consents.get(0);
      console.log('modalContent', modalContent);
      this.openModal(modalContent || {});
    } else {
      if (!this.data.unipol) {
        modalContent = conditionTextList.consents[type + suffix];
        console.log('modalContent', modalContent);
        modalContent.placet = this.placet;
        modalContent.supplyType = this.supplyType;
        modalContent.modalN = num;
        modalContent.unipol = this.isUnipol;
        modalContent.isProductVulnerable = this.isProductGasVulnerable;
        modalContent.productFamily = this.productFamily;
        this.openPrivacyModal(modalContent || {});
      }
      if (this.data.unipol) {
        modalContent = conditionTextList.consents[type + suffix];
        modalContent.placet = this.placet;
        modalContent.supplyType = this.supplyType;
        modalContent.modalN = num;
        modalContent.unipol = this.isUnipol;
        modalContent.isProductVulnerable = this.isProductGasVulnerable;
        this.openPrivacyModal(modalContent || {});
      }
    }
  }

  calculateTextSuffix(type): string {
    let suffix = '';
    if (type.startsWith('clauseCondition') || type.startsWith('attivazioneVeloce')) {
      if (this.data.product.family.toLowerCase() == 'placet') {
        if (!type.endsWith('-PLACET')) {
          suffix = '-PLACET';
        }
      } else if (this.isProductGasVulnerable) {
        suffix = '-VULNERABILI';
      }
    }
    if (type === 'attivazioneVeloce') {
      if (suffix.length > 0) {
        suffix = suffix.substring(1);
      }
    }
    if (paymentConditionTypeToReplace.includes(type) && this.isProductGasVulnerable) {
      suffix = '-VULNERABILI';
    }
    return suffix;
  }
  changeCheckbox(checkboxName) {
    switch (checkboxName) {
      case 'clause':
        this.readAcceptance.clauseCondition = !this.readAcceptance.clauseCondition;
        this.controlCheckboxesClause = !this.readAcceptance.clauseCondition;
        this.checkboxOutputClause.emit(!this.readAcceptance.clauseCondition);
        break;

      case 'consents':
        this.readAcceptance.cteCondition = !this.readAcceptance.cteCondition;
        this.readAcceptance.cfgCondition = !this.readAcceptance.cfgCondition;
        this.readAcceptance.cadastralCondition = !this.readAcceptance.cadastralCondition;
        this.readAcceptance.consentsCondition = !this.readAcceptance.consentsCondition;
        this.controlCheckboxesConsents = !this.readAcceptance.consentsCondition;
        this.checkboxOutputConsents.emit(!this.readAcceptance.consentsCondition);
        break;
    }
    this.consensoSerivce.updateGenericConsents({
      valid: this.contractForm.status === 'VALID',
      data: this.readAcceptance,
    });
  }

  openModalPdf() {
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: '',
      childComponent: AlgPdfModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: 'modal-title',
        modalClass: 'modal fade ngx-modal ngx-modal alternative-modal-pdf',
        contentClass: 'modal-content-pdf included-linear-modal',
      },
      data: {
        pdfSource: `${environment.documents.promoRegulation}/${this.actualPromoName$}.pdf`,
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-consenso-general-condition/alg-consenso-general-condition.component.ts